import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { useModalNavigation, useParams } from '@exam-management/router';
import { Button, type ButtonProps, AddRoundedIcon } from '@shared/components';

export default function AddQBSButton(props: Readonly<ButtonProps>) {
  const { courseId, qconfigId } = useParams('/exam-courses/:courseId/qconfigs/:qconfigId');
  const {
    qConfigData: { structures },
  } = useQConfig();

  const { open } = useModalNavigation(
    '/exam-courses/:courseId/qconfigs/:qconfigId',
    '/add-qbank-to-qconfig',
    {
      open: {
        params: {
          courseId,
          qconfigId,
        },
        state: {
          structures,
        },
      },
    },
  );

  const handleClick = () => {
    open();
  };
  return (
    <Button
      startIcon={<AddRoundedIcon />}
      variant='outlined'
      color='secondary'
      onClick={handleClick}
      {...props}
    >
      Add QBank
    </Button>
  );
}
